import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'
import global from '@/utils/global'
import mock from '@/mock/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/style.scss'
import _ from 'lodash'
import authc from '@/utils/authc'

Vue.use(ElementUI)
Vue.use(api)
Vue.use(authc)

Vue.prototype.global = global
Vue.prototype._ = _

Vue.use(new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
}))



// WEBPACK FOOTER //
// ./src/main.js